import { useParams } from "react-router-dom";
import EditUserComponent from "../../components/EditUserComponent/EditUserComponent";
import CustomAppBar from "../../components/CustomAppBar/CustomAppBar";
import PropTypes from "prop-types";
import SecureComponent from "../../components/SecApp/SecureComponent";
import { useConfig } from "../../contexts/ConfigContext";

function EditUserPage({ allowedRoles }) {
  const { config } = useConfig();
  const { tenant } = useParams();
  const theme = `${tenant}-theme`;
  return (
    <>
      <SecureComponent allowedRoles={allowedRoles}>
        <div className={theme} data-testid="theme-name">
          <CustomAppBar className="app-bar " config={config} />
          <EditUserComponent />
        </div>
      </SecureComponent>
    </>
  );
}
EditUserPage.propTypes = {
  config: PropTypes.object,
  allowedRoles: PropTypes.array,
};
export default EditUserPage;
